module.exports = __webpack_public_path__ + "img/txt_info3.9146b9a7.png";